import throttle from 'lodash/throttle'

class Header {
  constructor (el) {
    this.el = el
		this.trigger = el.querySelector('.nav-trigger__button')
		this.logo = el.querySelector('header__logo figure.image')
		this.main = document.querySelector('#main')

		this.checkBackground()
		this.addEvents()

		if (this.main) {
			this.main.style.paddingTop = `${this.el.offsetHeight}px`
		}
  }

	checkBackground () {
		if (window.scrollY > 0) {
			this.el.classList.add('bg-white')
			this.el.classList.add('header--sticky')
		} else {
			this.el.classList.remove('bg-white')
			this.el.classList.remove('header--sticky')
		}
	}

	addEvents () {
		// swap nav on scroll

		document.addEventListener('scroll', throttle(() => {
			this.checkBackground()
		}, 450))
	}
}

export default function(el) {
  new Header(el)
}
